
import { useState } from 'react';
import { Load } from '../types';
import { useToast } from '@/hooks/use-toast';

export const useLoadToggle = (initialLoads: Load[]) => {
  const [loads, setLoads] = useState<Load[]>(initialLoads);
  const { toast } = useToast();

  const handleToggleStatus = (id: string) => {
    setLoads(prevLoads => 
      prevLoads.map(load => 
        load.id === id 
          ? { 
              ...load, 
              status: !load.status,
              currentConsumption: !load.status ? load.powerRating : '0W'
            } 
          : load
      )
    );
    
    const load = loads.find(l => l.id === id);
    
    toast({
      title: `${load?.name} turned ${load?.status ? 'off' : 'on'}`,
      description: `The load has been ${load?.status ? 'deactivated' : 'activated'} successfully.`,
    });
  };

  return {
    loads,
    setLoads,
    handleToggleStatus,
  };
};
